/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { MARITAL_STATUS } from '../../../routes/routes';
import './DriversLicence.css';
import { ProgressBar, Button, Dropdown, Image, Form } from 'react-bootstrap';
import { postToController } from '../../../actions/apiActions';
import { navigateTo } from '../../../actions/navigationActions';
import { setLicenceData } from '../../../actions/salesActions';
import { DatePicker, DatePickerInput } from 'rc-datepicker';
import ModernDatepicker from 'react-modern-datepicker';

class DriversLicence extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            driversLicenceList: [],
            minDate: new Date(),
            maxDate: new Date(),
            selectedDate: "",
            SelectedDriversLicence: null,
            SelectedDriversLicenceDropdown: false,
            hasSubmitted: false,
            loggedIn: this.props.auth.uid ? true : false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
        this.getDriversLicence = this.getDriversLicence.bind(this);
        this.handleDriversLicenceSelection = this.handleDriversLicenceSelection.bind(this);
        this.handleSelectedDriversLicenceDropdownToggle = this.handleSelectedDriversLicenceDropdownToggle.bind(this);
    }

    async componentDidMount() {
        if (this.state.driversLicenceList.length === 0) {
            await this.getDriversLicence();
        }
        let currDate = new Date();
        let idNumber = "";
        if (this.props.sales.idNumber) {
            idNumber = this.props.sales.idNumber.toString();
        } else {
            idNumber = this.props.profile.idNumber.toString();
        }
        let idYear = parseInt(idNumber.substring(0, 2));
        idYear += (idYear >= currDate.getFullYear() - 2000) ? 1900 : 2000;

        let minMonth = idNumber.substring(2, 4);
        let minDay = parseInt(idNumber.substring(4, 6));
        let minDateTime = new Date((idYear + 18).toString() + "-" + minMonth + "-" + minDay.toString());
        let maxDateTime = new Date();

        await this.setState({ maxDate: maxDateTime, minDate: minDateTime })
    }

    async handleDriversLicenceSelection(e: any) {
        /* eslint eqeqeq: "off" */
        let driverLicence = this.state.driversLicenceList.filter(function (item) {
            return item.id == e;
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({ SelectedDriversLicence: driverLicence[0] });
        await this.checkSubmit()
    }

    async checkSubmit() {
        /* eslint eqeqeq: "off" */
        this.setState({ nextDisabled: !(this.state.SelectedDriversLicence && this.state.selectedDate !== "") });
        /* eslint eqeqeq: "warn" */
    }

    async handleDateChange(e: any) {
        await this.setState({
            selectedDate: e
        });
        await this.checkSubmit()
    }

    async handleSelectedDriversLicenceDropdownToggle(e: any) {
        await this.setState({
            SelectedDriversLicenceDropdown: !this.state.SelectedDriversLicenceDropdown
        });
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    handleClick() {
        this.props.dispatchSetLicenceData(this.state.selectedDate, this.state.SelectedDriversLicence)
    }

    async handleBack(e: any) {
        this.props.redirectTo(MARITAL_STATUS)
    }

    async getDriversLicence() {
        await postToController(this.props.dispatch, 'GetDriversLicenceSelection', JSON.stringify({Parameter : this.props.profile.countryId})).then(async (response) => {
            await this.setState({ driversLicenceList: response });
            return true;
        })
    }

    public render() {
        let DriversLicenceDrop = [];
        if (this.state.driversLicenceList.length > 0) {
            DriversLicenceDrop = this.state.driversLicenceList.map((item) => {
                return <Dropdown.Item key={item.id} eventKey={item.id}>{item.description}</Dropdown.Item>
            });
        }
        return (
            <div id="DriversLicence" className={this.state.loggedIn ? "pt-lg-5 picker-padding logged-in" : "pt-lg-5 picker-padding logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={70} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="mt-5 text-center">
                                    <img src="./images/OnlineQuotation/crown-icon.png" className="img-fluid" alt="" />
                                </div>
                                <div className="ma-top-21px text-center">
                                    <p className="font-size-16px font-weight-500">Shweet, now we need the year and code of the regular<br className="d-none d-lg-block" /> driver’s licence</p>
                                </div>
                                <div className="row ma-top-30px">
                                    <div className="col-lg-12 col-md-12 col-12 p-lg-0">
                                        <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.SelectedDriversLicence  ? "" : " no-opacity")}>Licence code</Form.Label>
                                        <Dropdown
                                            id="driverLicence-select-dropdown"
                                            className="fit-full"
                                            onSelect={this.handleDriversLicenceSelection}
                                            onToggle={this.handleSelectedDriversLicenceDropdownToggle}>
                                            <Dropdown.Toggle id="dropdown-basic">
                                                <div className="row dropdown-height">
                                                    <div className="dropdown-basic-title-text col-11">
                                                        {this.state.SelectedDriversLicence &&
                                                            this.state.SelectedDriversLicence.description}
                                                        {!this.state.SelectedDriversLicence &&
                                                            <p>Licence code</p>
                                                        }
                                                    </div>
                                                    <Image src='Images/red-arrow-up-24-px.svg' className={this.state.SelectedDriversLicenceDropdown ? 'visible' : 'invisible'} alt="" />
                                                    <Image src='Images/red-arrow-down-24-px.svg' className={this.state.SelectedDriversLicenceDropdown ? 'invisible' : 'visible'} alt="" />
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu id='driverLicenceDropDown'>
                                                {DriversLicenceDrop}
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        <div className="mb-4">
                                            <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.selectedDate !== "" ? "" : " no-opacity")}>Licence first issued on (YYYY-MM-DD)</Form.Label>
                                            {/*<DatePickerInput*/}
                                            {/*    displayFormat='YYYY/MM/DD'*/}
                                            {/*    returnFormat='YYYY-MM-DD'*/}
                                            {/*    onChange={(date) => this.handleDateChange(date)}*/}
                                            {/*    value={this.state.selectedDate}*/}
                                            {/*    className='calendar-inline-icon'*/}
                                            {/*/>*/}


                                            {/*<DatePicker position={ "bottom" } onChange={this.handleDateChange} value={this.state.selectedDate} />*/}

                                            <ModernDatepicker
                                                date={this.state.selectedDate}
                                                format={'YYYY-MM-DD'}
                                                showBorder
                                                onChange={(date) => this.handleDateChange(date)}
                                                placeholder={'Licence first issued on (YYYY-MM-DD)'}
                                                className="calendar-inline-icon"
                                            />

                                            {this.state.hasSubmitted && this.state.driversLicenceDate &&
                                                <div className="help-block">License date acquired is required</div>
                                            }
                                        </div>
                                    </div>


                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-3 col-md-3 col-xs-12 col-sm-12 mt-5">
                                        <Button className="btn btn-block btn-solid-red" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        auth: state.firebase.auth,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetLicenceData: (Date: string, Code: any) => dispatch(setLicenceData(Date,Code))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DriversLicence);